import styled from 'styled-components';

export const AppointmentCard = styled.div`
  display: flex;
  border: 1px solid ${p => (p.isActive ? p.theme.color.borderActive : p.theme.color.border)};
  background-color: ${p => p.isActive && p.theme.color.active};
  border-radius: 4px;
  align-items: center;
  position: relative;
  margin-bottom: 0.5em;
  &:hover {
    cursor: pointer;
  }
  & > img {
    display: ${props => (props.isActive ? 'block' : 'none')};
    position: absolute;
    right: 0.7em;
    width: 1em;
    height: 1em;
    top: 36%;
  }
  .time-block {
    border-right: 1px solid ${p => p.theme.color.border};
  }
  .patient-block {
    padding: 0 0.5em 0 0;
    label {
      display: none;
    }
  }
`;

export const AppInfCaption = styled.div`
  > p {
    margin: -0.5em 0 0.3em;
  }
`;

export const AppInfCaptionContent = styled.div`
  background: ${p => p.theme.color.background};
  border-radius: 4px;
  display: flex;
  padding: 0.5em 0;
  > div {
    width: 50%;
    box-sizing: border-box;
    &:first-of-type {
      padding: 0 1em;
      border-right: 1px solid ${p => p.theme.color.border};
    }
    &:nth-of-type(2) {
      padding-left: 2em;
    }
  }
  p {
    margin: 0;
    span {
      padding-right: 5px;
      display: inline-block;
      &.additional-info {
        white-space: nowrap;
        font-size: 0.85em;
        color: ${p => p.theme.color.label};
        &.with-left-border {
          padding-left: 5px;
          border-left: 1px solid ${p => p.theme.color.border};
        }
      }
      &.last-name {
        font-size: 1em;
        font-weight: bold;
        text-transform: uppercase;
      }
    }
  }
  .full-width {
    display: inline-block;
    line-height: 100%;
    width: 100%;
  }
  .label {
    font-size: 0.85em;
    color: ${p => p.theme.color.label};
  }
`;

export const ColumnsWrapper = styled.div`
  display: flex;
  border-top: 1px solid ${p => p.theme.color.border};
  border-bottom: 1px solid ${p => p.theme.color.border};
  > section {
    min-height: 400px;
    width: 50%;
    box-sizing: border-box;
    &:first-of-type {
      padding: 0 30px 12px 30px;
      border-right: 1px solid ${p => p.theme.color.border};
    }
    h3 {
      color: ${p => p.theme.color.text};
      font-weight: normal;
      margin-bottom: 0.5em;
    }
  }
  textarea {
    min-height: 4.1em;
  }
  .bn-m-small {
    color: ${p => p.theme.color.label};
    font-size: 0.9em;
    margin-bottom: 0.3em;
    & + div {
      margin-bottom: 10px;
      > div {
        margin-bottom: 0;
      }
    }
  }
  .input-label:not(:empty) {
    font-size: 0.9em;
    margin-bottom: 0;
  }
  .appointments-list {
    position: relative;
    h3 {
      padding: 0 30px;
      margin-bottom: -0.4em;
    }
  }
  .empty-data {
    color: ${p => p.theme.color.label};
    padding-top: 20%;
    text-align: center;
    p {
      margin: 0.5em;
    }
  }
  .scroll-content {
    height: calc(100% - 10em);
    position: absolute;
    overflow: auto;
    width: 100%;
    padding: 0.4em 30px 0;
    box-sizing: border-box;
    &.with-scroll {
      padding-right: 17px;
    }
  }
`;
